module.exports = __webpack_public_path__ + "img/SplashScience4.1ae463b0.jpg";